import { api } from '../../lib/api';
import type { OutreachClosedReason, OutreachLeadRow, OutreachLeadStatus } from '../../../shared/types';
import { statusPatch } from './helpers';

export const ENDPOINT = '/api/admin/outreach-leads';

// ── Requests (thin, so a test can drive them without a DOM) ──────────────

export async function fetchOutreachLeads(): Promise<OutreachLeadRow[]> {
  const data = await api<{ leads: OutreachLeadRow[] }>(ENDPOINT);
  return data.leads;
}

export async function applyStatus(
  lead: OutreachLeadRow,
  status: OutreachLeadStatus,
  closedReason: OutreachClosedReason | null = null,
): Promise<void> {
  await api(`${ENDPOINT}/${lead.id}`, { method: 'PATCH', json: statusPatch(status, closedReason) });
}

export async function promoteLead(lead: OutreachLeadRow): Promise<void> {
  await api(`${ENDPOINT}/${lead.id}`, { method: 'PATCH', json: { promote: true } });
}

export async function deleteLead(lead: OutreachLeadRow): Promise<void> {
  await api(`${ENDPOINT}/${lead.id}`, { method: 'DELETE' });
}
